import { RefObject, useEffect, useRef, useState } from 'react';

export function useComponentWidth(): [RefObject<HTMLElement | null>, number] {
    const ref = useRef<HTMLElement | null>(null);
    const [width, setWidth] = useState(0);

    useEffect(() => {
        if (!ref.current) return;

        const observer = new ResizeObserver(([entry]) => {
            setWidth(entry?.contentRect.width ?? 0);
        });

        observer.observe(ref.current);

        return () => observer.disconnect();
    }, []);

    return [ref, width];
}
